/* global swal google */
import './style.less';

import moment from 'moment-timezone';

export default function(
  $log,
  $timeout,
  $q,
  $state,
  $stateParams,
  $uibModal,
  Upload,
  ProfileClass,
  ApiClass,
  Swal,
  store,
  TimeZoneClass,
  ResolveClass
) {
  'ngInject';

  const vm = this;
  const userGuessTimeZoneId = moment.tz.guess();

  vm.$onChanges = activate;

  function setClasses() {
    const labelClasses = { true: 'sr-only', false: 'col-lg-2 col-md-3 col-sm-4 col-xs-12' }[!!vm.hideLabel];
    const inputClasses = {
      true: 'col-lg-12 col-md-12 col-sm-12 col-xs-12',
      false: 'col-lg-10 col-md-9 col-sm-8 col-xs-12'
    }[!!vm.hideLabel];
    const headerClass = 'col-lg-6 col-md-6 col-sm-12 col-xs-12';

    vm.headerClasses = vm.headerColumn || headerClass;
    vm.labelClasses = vm.labelColumn || labelClasses;
    vm.inputClasses = vm.inputColumn || inputClasses;
  }

  vm.resultsQueried = false;
  vm.passwordChange = false;
  vm.adminEdit = ResolveClass.isAdminRoute();

  vm.timeZoneList = TimeZoneClass.selectList;

  const { profile } = ProfileClass.profileComplete;

  vm.admin = !!profile.admin;

  vm.update = () => {
    vm.profileUpdate = true;
    if (vm.formData.hireDate) vm.formData.hire_date = new Date(vm.formData.hireDate).toISOString();

    if (!vm.admin) delete vm.formData.objectguid;
    else if (vm.formData.objectguid) vm.formData.objectguid.toUpperCase();

    return ApiClass.usersIdPatch({ id: vm.ngProfileUid }, vm.formData)
      .then(() => {
        vm.profileUpdate = false;
        Swal.toast('Profile Updated!');
        if (vm.successCallback) vm.successCallback(vm.successCallbackArgs);
      })
      .catch(error => {
        if (error.status === 422)
          return Swal.alert('Error', 'Error updating profile, User Sync ID is used by another firm member.', 'error');
        vm.profileUpdate = false;
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  /**
   * Takes an address data ojbect and maps its values on to the current component model
   *
   * @param {Object} locationData - object matching our location data interface
   * @param {Function} applyModel - applies the model the view after the model is updated
   */
  vm.setLocation = (locationData, applyModel) => {
    vm.formData = { ...vm.formData, ...locationData };
    applyModel();
  };

  function activate() {
    $log.debug('Users Profile Controller Activated');

    if (!vm.ngProfileUid) return;

    const qArr = [ApiClass.usersIdGet({ id: vm.ngProfileUid }, {}, {})];

    if (!vm.adminEdit) {
      vm.passwordChange = !!store.get('user_id');
    }

    setClasses();

    $q.all(qArr)
      .then(([{ data: { item: profile } }]) => {
        vm.formData = profile;
        vm.formData.timeZoneId = profile.timeZoneId || userGuessTimeZoneId;
        vm.formData.hireDate = new Date(profile.hire_date || Date.now());
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/profile/controller.js